<template>
  <div>
    <div class="row no-gutters vertical-offset-100">
      <div class="col-10 col-sm-8 col-md-6 col-lg-4 col-xl-3 mx-auto">
        <div class="card card-outline-secondary">
          <div class="card-header">
            <h3 class="mb-0">
              QLite Warehouse Portal
            </h3>
          </div>
          <div
            id="main-card-body"
            class="card-body"
          >
            <form
              id="form-signin"
              class="form-signin"
              role="form"
              autocomplete="off"
            >
              <fieldset>
                <div class="form-group text-left">
                  <label for="username-label">Email address</label>
                  <b-form-input
                    v-model="email"
                    v-b-tooltip.hover
                    class="form-control"
                    placeholder="Your sky email address"
                    :state="emailState"
                    title="Press Enter to submit"
                    :formatter="format"
                    style="margin-bottom: 0;"
                    @keyup.enter.native="clickedLogin()"
                  />
                  <b-alert
                    variant="danger"
                    dismissible
                    :show="showEmailError && !emailState"
                    @dismissed="showEmailError=false"
                  >
                    Your email needs to be ending with @sky.uk, @sky.de, @sky.at or @iwedia.com
                  </b-alert>
                </div>
                <div id="usname_alert" />
                <div class="form-group text-left">
                  <label for="password-label">Password</label>
                  <input
                    v-model="password"
                    class="form-control"
                    placeholder="Password"
                    type="password"
                    required="true"
                    autocomplete="off"
                    @keyup.enter="clickedLogin()"
                  >
                  <b-alert
                    variant="danger"
                    dismissible
                    :show="showPasswordError"
                    @dismissed="showPasswordError=false"
                  >
                    Your password must be of at least 8 characters containing numbers, special character, uppercase and lowercase letters
                  </b-alert>
                </div>
                <div
                  class="form-group"
                  style="text-align: right;"
                >
                  <p
                    id="button-forgot-password"
                    @click="clickedForgotPassword()"
                  >
                    Forgot password
                  </p>
                </div>
                <div class="text-right">
                  <b-btn
                    id="button-login"
                    class="btn btn-sm btn-success"
                    type="button"
                    :disabled="!emailState || !isPasswordValid || is_signing_in"
                    @click="clickedLogin()"
                  >
                    <i
                      v-show="is_signing_in"
                      class="fa fa-spinner fa-spin"
                    /> Login »
                  </b-btn>
                </div>
                <div
                  class="text-left"
                  style="margin-bottom: 0.5rem;"
                >
                  <dt>Don't have an account?</dt>
                </div>
                <input
                  id="signup"
                  class="btn btn-block btn-success"
                  :disabled="is_signing_in"
                  value="Sign Up"
                  @click="clickedSignUp()"
                >
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div>
      <ForgotPasswordComponent
        :initial-email="email"
        @reset-password-data-email="receivedResetPasswordEmail"
      />
    </div>

    <div>
      <ResetPasswordComponent :initial-email="resetPasswordEmail" />
    </div>

    <div>
      <SignUpComponent
        :initial-email="email"
        @sign-up-data-email="receivedSignUpEmail"
      />
    </div>

    <div>
      <SignUpConfirmCodeComponent
        :user="userFromSignUp"
        @confirmed-code="confirmedCode"
      />
    </div>

    <div>
      <ChangePasswordComponent
        :initial-email="email"
        :old-password="password"
      />
    </div>
  </div>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

import ForgotPasswordComponent from './ForgotPasswordComponent.vue'
import ResetPasswordComponent from './ResetPasswordComponent.vue'
import SignUpComponent from './SignUpComponent.vue'
import SignUpConfirmCodeComponent from './SignUpConfirmCodeComponent.vue'
import ChangePasswordComponent from './ChangePasswordComponent.vue'

import utils from '../../utils.js'

import USER_API from '../../api/user'

import {
	USER_ADMIN
} from '../../constants'

export default {

	components: {
		ForgotPasswordComponent,
		ResetPasswordComponent,
		SignUpComponent,
		SignUpConfirmCodeComponent,
		ChangePasswordComponent
	},
	data () {
		return {
			email: '',
			confirmCodePassword: '',
			resetPasswordEmail: '',
			password: '',
			showLoading: false,
			is_signing_in: false,
			showEmailError: false,
			showPasswordError: false,

			isPasswordValid: false,

			disable_all: false,

			userFromSignUp: {}
		}
	},

	computed: {
		emailState () {
			const isEmailValid = utils.validateEmail(this.email)

			console.log('emailState: ' + isEmailValid)

			return isEmailValid
		}
	},

	watch: {
		password: {
			handler: function (password) {
				this.isPasswordValid = this.password.trim() !== ''
			},
			immediate: true
		}
	},

	mounted () {
		// `this` points to the vm instance
		if (process.env.NODE_ENV != 'production') {
			this.email = 'chris.danguien@sky.uk'
			this.password = 'aaaaaaaaOO001!'
		}

		// utils.testStuff();
	},

	methods: {
		format: function (value, event) {
			return value.toLowerCase()
		},

		receivedResetPasswordEmail: function (email) {
			this.resetPasswordEmail = email
		},

		receivedSignUpEmail: function (email, alias, password) {
			this.confirmCodePassword = password

			this.userFromSignUp = {
				email: email,
				alias: alias,
				password: password
			}
		},

		clickedForgotPassword: function () {
			this.$root.$emit('bv::show::modal', 'forgot-password-modal')
		},

		clickedLogin: function () {
			if (this.validateInput()) {
				this.signIn(this.email, this.password)
			}
		},

		clickedSignUp: function () {
			this.$root.$emit('bv::show::modal', 'sign-up-modal')
		},

		validateInput: function () {
			if (!utils.validateEmail(this.email)) {
				console.log('validateInput, email invalid')

				this.showEmailError = true

				return false
			} else if (!utils.validatePassword(this.password)) {
				console.log('validateInput, password invalid')

				this.showPasswordError = true

				return false
			} else {
				console.log('validateInput, every thing is fine')

				this.showEmailError = false
				this.showPasswordError = false

				return true
			}
		},

		signIn: function (email, password) {
			this.is_signing_in = true

			const params = {
				email: email,
				password: password
			}

			const reference = this

			USER_API.sign_in(params,
				(response) => {
					console.debug(response)

					reference.$store.dispatch('setUser', { email: email })
					/*
					const groups = response['group_list']
					if (groups.includes('admin-users')) {
						reference.$router.push('home')
					}
					*/
					reference.$router.push('home')

					reference.is_signing_in = false
				},
				e => {
					console.debug(e)

					reference.is_signing_in = false

					if (e.hasOwnProperty('response')) {
						const response = e['response']

						if (response.hasOwnProperty('data')) {
							const data = response['data']

							if (data.hasOwnProperty('unconfirmed')) {
								const unconfirmed = data['unconfirmed']

								if (unconfirmed) {
									reference.$root.$emit(
										'bv::show::modal',
										'sign-up-confirm-code-modal'
									)
								}
							}
							if (data.hasOwnProperty('error')) {
								const error = data['error']
								utils.makeToast(reference.$bvToast, 'Error', 'danger', error)

								return
							}
						}
					}

					utils.makeToast(reference.$bvToast, 'Error', 'danger', "You couldn't be signed-in, please try again")
				}
			)
		},

		amazonAuthorizeUser: function (email, password) {
			this.is_signing_in = true

			const params = {
				email: email,
				password: password
			}

			const reference = this

			USER_API.sign_in(params,
				(response) => {
					console.debug(response)

					const groups = response['group_list']
					if (groups.includes('admin-users')) {
						reference.$router.push('trial-list-management')
					} else {
						reference.$router.push('software-management')
					}

					reference.is_signing_in = false
				},
				e => {
					console.debug(e)

					reference.is_signing_in = false

					if (e.hasOwnProperty('response')) {
						const response = e['response']

						if (response.hasOwnProperty('data')) {
							const data = response['data']

							if (data.hasOwnProperty('unconfirmed')) {
								const unconfirmed = data['unconfirmed']

								if (unconfirmed) {
									reference.$root.$emit(
										'bv::show::modal',
										'sign-up-confirm-code-modal'
									)
								}
							}
							if (data.hasOwnProperty('error')) {
								const error = data['error']
								utils.makeToast(reference.$bvToast, 'Error', 'danger', error)

								return
							}
						}
					}

					utils.makeToast(reference.$bvToast, 'Error', 'danger', "You couldn't be signed-in, please try again")
				}
			)

			/*
      NEED TO MANAGE THAT
            newPasswordRequired: function(userAttributes, requiredAttributes) {
            //display a change your password screen
            reference.is_signing_in = false;

            reference.amazonNewPasswordRequired();
          }
      */
		},

		amazonNewPasswordRequired: function () {
			this.$root.$emit('bv::show::modal', 'change-password-modal')
		},

		confirmedCode: function (email, password) {
			const reference = this

			this.signIn(email, password)
		}
	}
}
</script>
<!--
  STYLE
-->
<style scoped>
#login {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#button-login {
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.form-signin input[type="text"] {
  margin-bottom: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.form-signin .form-control {
  position: relative;
  font-size: 16px;
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
  height: auto;
  padding: 10px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.vertical-offset-100 {
  padding-top: 100px;
}

.img-responsive {
  display: block;
  max-width: 100%;
  height: auto;
  margin: auto;
}

.card {
  font-size: 16px;
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
  background-color: rgba(255, 255, 255, 0.75);
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.well {
  background-color: rgba(255, 255, 255, 0.4);
}

#button-forgot-password {
  color: #007bff;
  text-decoration: underline;
  background: transparent;
  border: none;
}

#button-forgot-password:focus {
  outline: none;
}

#button-forgot-password:hover {
  cursor: pointer;
}

#warning-label-website-usage {
  font-size: 10pt;
  margin-top: 1rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  text-align: left;
  color: red;
  font-style: italic;
}
</style>
